import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/search-gray.png'
import _imports_1 from '@/assets/img/upload-white.png'


const _withScopeId = n => (_pushScopeId("data-v-a8cbb28c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-bottom" }
const _hoisted_2 = { class: "tabbar" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "search-upload" }
const _hoisted_5 = {
  key: 0,
  class: "search"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = ["onKeyup"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "上传资源", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]

import useHomeStore from '@/store/modules/home'
import useSearchStore from '@/store/modules/search';
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {
  __name: 'header-bottom',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const homeStore = useHomeStore()
const searchStore = useSearchStore()
const { defaultTab, showUpload, isLogin, showLogin, loginFromPersonSpace } = storeToRefs(homeStore)
// const { searchKeyWord } = storeToRefs(searchStore)
const itemClick = (item, index) => {
  if (item.name == '个人空间') {
    if (!isLogin.value) {
      showLogin.value = true
      loginFromPersonSpace.value = true
      return
    }
    defaultTab.value = -1
    router.push(item.path)
    return
  }else if( item.name == '精品课堂') {
    console.log('xxx')
    // 部署后
    //cs调试
    window.open('#/pcourse','_blank')
    return
  }
  defaultTab.value = index
  router.push(item.path)
}

const searchKeyWord = ref('')
const tabbar = [
  {
    path: '/home',
    name: '首页'
  },
  {
    path: '/pcourse',
    name: '精品课堂'
  },
  {
    path: '/home/cousrseResources',
    name: '微课资源'
  },

  {
    path: '/home/documents',
    name: '教学文档'
  },
  {
    path: '/home/achievements',
    name: '研修成果'
  },
  {
    path: '/personSpace',
    name: '个人空间'
  },

]

//点击上传资源
const clickUpload = () => {
  if (!isLogin.value) {
    showLogin.value = true
    return
  }
  showUpload.value = true
}

//点击搜索
const clickSearch = async () => {
  if (searchKeyWord.value) {
    await searchStore.getSeach(searchKeyWord.value)
  }
  defaultTab.value = null
  router.push({
    path: '/home/search',
    query:{
      searchKeyWord:searchKeyWord.value
    }
  })
  searchKeyWord.value = ''

}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabbar, (item, index) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["tabbar-item", _unref(defaultTab) ==  index ? 'checked' :'']),
          onClick: $event => (itemClick(item, index)),
          key: index
        }, [
          _createElementVNode("span", null, _toDisplayString(item.name), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["horizontal-line", _unref(defaultTab) ==  index ? 'checked' :''])
          }, null, 2)
        ], 10, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_unref(route).path.includes('home/search'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((searchKeyWord).value = $event)),
              onKeyup: _withKeys(clickSearch, ["enter"]),
              placeholder: "请输入您的关键词"
            }, null, 40, _hoisted_7), [
              [
                _vModelText,
                searchKeyWord.value,
                void 0,
                { trim: true }
              ]
            ]),
            _createElementVNode("div", {
              class: "search-btn",
              onClick: clickSearch
            }, "搜索")
          ]))
        : _createCommentVNode("", true),
      (!_unref(route).path.includes('upload'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "upload",
            onClick: clickUpload
          }, _hoisted_10))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}